import { motion, useReducedMotion } from "framer-motion";

/**
 * Subtle, accessible scroll-reveal wrapper.
 * Respects prefers-reduced-motion by rendering static content.
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
